import { environment } from 'src/environments/environment';

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const SubOfficeApiResources = {
  // list:  createUrl('bids'),
  // search:  createUrl('bids/search'),
  create:  createUrl('user-sub-office/create'),
  listing:  createUrl('user-sub-office'),
  // addBidder:  createUrl('bids/add/bidder'),
  // removeBidder:  createUrl('bids/remove/bidder'),
  // changeStatus:  createUrl('bids/change/status'),
  // onHold:createUrl('bids/on-hold'),

  // detail:  createUrl('bids'),
  update:  createUrl('user-sub-office'),
  delete:  createUrl('user-sub-office'),
  changeStatus:  createUrl('user-sub-office/change-status'),
};
